
<app-reports-toolbar></app-reports-toolbar>
<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message>
<button (click)='downloads()' class="roboto-bold ms-4" id="btn">FETCH REPORT</button>
